const months: Map<number, string> = new Map([
  [1, 'Enero'],
  [2, 'Febrero'],
  [3, 'Marzo'],
  [4, 'Abril'],
  [5, 'Mayo'],
  [6, 'Junio'],
  [7, 'Julio'],
  [8, 'Agosto'],
  [9, 'Setiembre'],
  [10, 'Octubre'],
  [11, 'Noviembre'],
  [12, 'Diciembre'],
]);

export const getNameMonth = (month: number): string => months.get(month);

export const numberToMillons = (value: number): number => {
  const million = 1000000;
  return Number((value / million).toFixed(2));
};

export const formatNumber = (value: number): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    currency: 'USD',
  });
  return formatter.format(value);
};
